export default __webpack_public_path__ + "static/media/iconServices.a3547265.svg";